export function getLinkTarget(button) {
  return button?.openInNewTab ? "_blank" : "_self";
}
